import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ClientListService } from 'src/app/core/services/list-services/client-list.service';
import { ContactListService } from 'src/app/core/services/list-services/contact-list.service';
import { UserListService } from 'src/app/core/services/list-services/user-list.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AttendeeModel } from 'src/app/core/models/calendar/attendee.model';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { CalendarEventStatusEnum } from 'src/app/core/enums/calendar-status-enum';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-attendees-selection',
  templateUrl: './attendees-selection.component.html',
  styleUrls: ['./attendees-selection.component.scss']
})
export class AttendeesSelectionComponent {
  listItems: any[] = [];

  emailPattern = GlobalComponent.emailPattern;

  trackByFn: number = 0;
  searchTermLength: number = 0;
  listItemsLoading: boolean = false;

  disabled: boolean = false;
  searchTerm: string | undefined;
  minLengthTerm: number = 1;
  @Input() searchPlaceHolderText: string = 'Add attendees';
  @Input() selectedModelsArray: any[] = [];
  @Input() maxItems: number = 99; 
  @Input() searchFieldStyle: boolean = false;

  searchTerm$ = new Subject<string>();

  attendeesList: AttendeeModel[] = [];

  invalidEmail: boolean = false;

  enumCalendarEventStatus = CalendarEventStatusEnum; 

  enumEntityType = EntityTypeEnum;

  protected securityPermissionClientSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement);
  protected securityPermissionContactSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement);
  protected securityPermissionUserSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userManagement);

  @Output() updateAttendees = new EventEmitter<AttendeeModel[]>();

  constructor(
    protected authMyFileService: AuthMyfileService,
    protected clientListService: ClientListService,
    protected contactListService: ContactListService,
    protected userListService: UserListService,
    protected myFileApiService: MyfileApiService,
    protected openModalService: OpenModalService,
    protected toasterNotificationService: ToasterNotificationService,
    protected router: Router,
  ) { }


  ngOnInit(): void {

    if(this.searchFieldStyle == true)[
      this.searchPlaceHolderText = `Search by attendees`
    ]

    this.searchTerm$.subscribe(search => {
      if (search != undefined) {
        this.searchTerm = search;
        this.searchTermLength = this.searchTerm!.length;
        this.listItems = [];
        if (this.searchTerm!.length >= this.minLengthTerm) {

          if (this.securityPermissionClientSearch) {
            this.clientListService.searchTerm = this.searchTerm!;
          }
          if (this.securityPermissionContactSearch) {
            this.contactListService.searchTerm = this.searchTerm!;
          }
          if (this.securityPermissionUserSearch) {
            this.userListService.searchTerm = this.searchTerm!;
          }
        }
      }
    })
    if (this.securityPermissionClientSearch) {
      this.clientListService.resultItems$.subscribe((result) => {
        result.forEach((model: any) => {
          model.modelType = EntityTypeEnum.Client;
        })
        this.listItems = this.listItems.concat(result);
      })
    }

    if (this.securityPermissionContactSearch) {
      this.contactListService.resultItems$.subscribe((result) => {
        result.forEach((model: any) => {
          model.modelType = EntityTypeEnum.Account;
        })
        this.listItems = this.listItems.concat(result);
      })
    }

    if (this.securityPermissionUserSearch) {
      this.userListService.resultItems$.subscribe((result) => {
        result.forEach((model: any) => {
          model.modelType = EntityTypeEnum.User;
        })
        this.listItems = this.listItems.concat(result);
      });
    }
  }

  addCustomEmail(email: any) {
    if (GlobalComponent.emailPattern.test(email)) {
      var attendee: AttendeeModel = new AttendeeModel('', EntityTypeEnum.Other, CalendarEventStatusEnum.Tentative, email, email);
      return attendee;
    } else {
      return undefined;
    }
  }

  arrayCleared() {
    this.searchTermLength = 0;
    this.attendeesList = [];
  }

  addModelToArray(event?: any[]) {
    this.searchTermLength = 0;
    this.attendeesList = [];
    if (event) {
      event.forEach(model => {
        if (model.modelType != undefined) {
          if (model.modelType === EntityTypeEnum.Account) {
            var attendee: AttendeeModel = new AttendeeModel(model.id, model.modelType, CalendarEventStatusEnum.Tentative, model.fullName, model.email);
            this.attendeesList.push(attendee)
          } else {
            var attendee: AttendeeModel = new AttendeeModel(model.id, model.modelType, CalendarEventStatusEnum.Tentative, `${model.name} ${model.lastName}`, model.email);
            this.attendeesList.push(attendee)
          }
        } else {
          this.attendeesList.push(model)
        }
      });
    }
    this.updateAttendees.emit(this.attendeesList);

  }

  validEmailString(email: string | undefined): boolean {
    if (email && GlobalComponent.emailPattern.test(email)) {
      return true;
    }
    return false
  }

  getDropdownName(item: any) {
    if (item.firstName && item.firstName != '' && item.companyName && item.companyName != '') {
      return `${item.fullName} - ${item.companyName}`;
    } else {
      return `${item.fullName}`;
    }
  }

  removeFromArray(id: string) {
    this.selectedModelsArray.splice(this.selectedModelsArray.findIndex(item => item.id === id), 1);
    this.attendeesList.splice(this.attendeesList.findIndex(item => item.id === id), 1);
    this.updateAttendees.emit(this.attendeesList);
  }

  statusTextClass(status: CalendarEventStatusEnum) {
    switch (status) {
      case CalendarEventStatusEnum.Accepted:
        return 'coloredTextArea green';
      case CalendarEventStatusEnum.Declined:
        return 'coloredTextArea red';
      case CalendarEventStatusEnum.Tentative:
        return 'coloredTextArea orange';
      default:
        return '';
    }
  }

  statusText(status: CalendarEventStatusEnum) {
    switch (status) {
      case CalendarEventStatusEnum.Accepted:
        return 'Accepted';
      case CalendarEventStatusEnum.Declined:
        return 'Declined';
      case CalendarEventStatusEnum.Tentative:
        return 'Tentative';
      default:
        return '';
    }
  }

}
